import React, {
  FC,
  ReactNode,
  createContext,
  useContext,
  useMemo,
} from 'react';
import { useJsApiLoader } from '@react-google-maps/api';

interface GoogleApiProviderProps {
  children: ReactNode;
}

interface GoogleMapsStatus {
  isLoaded: boolean;
  loadError?: Error;
}

const googleApiKey =
  process.env.REACT_APP_GOOGLE_API_KEY ??
  'AIzaSyCABoBajwP5JARmturb8sgkTyCMft3O3KI';

const libraries: any[] = ['places', 'geocoding'];

// Defaults to "not loaded" so a component rendered outside the provider falls
// back to its no-Maps state instead of touching an undefined `google` global.
const GoogleMapsContext = createContext<GoogleMapsStatus>({ isLoaded: false });

export const useGoogleMaps = () => useContext(GoogleMapsContext);

// Loads the Maps script in the background and always renders its children.
// Components that need Maps read `useGoogleMaps()` and wait on their own, so a
// slow or blocked script never holds back the rest of the page.
export const GoogleApiProvider: FC<GoogleApiProviderProps> = ({
  children,
}: GoogleApiProviderProps) => {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: googleApiKey,
    id: 'pv-google-location-selector',
    version: 'weekly',
    libraries,
  });
  const status = useMemo(
    () => ({ isLoaded, loadError }),
    [isLoaded, loadError]
  );

  return (
    <GoogleMapsContext.Provider value={status}>
      {children}
    </GoogleMapsContext.Provider>
  );
};
